/** @format */
// export const ROUTE_BASED_URL = process.env.REACT_APP_ROUTE_BASED_URL;
export const ROUTE_BASED_URL = `${process.env.REACT_APP_ROUTE_BASED_URL}/api/v1/`;
export const GOOGLE_CLIENT_ID = `${process.env.REACT_APP_GOOGLE_CLIENT_ID}`;
export const RAZORPAY_KEY = `${process.env.REACT_APP_RAZORPAY_KEY_ID}`;
export const ENVIRONMENT = `${process.env.REACT_APP_ENVIRONMENT}`;
